import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn, H3 } from "../../../AbstractElements";
import { Cancel, Save } from "../../../Shared/Constants";
import { useForm } from "react-hook-form";
import InputError from "../../../Shared/Components/Form/InputError";

import { togleLoading } from "../../../Shared/Utils/alertLoading";
import RoleFormPermissions from "./RoleFormPermissions";
import RoleContext from "./../ContextProvider/Index";

export default function RoleForm() {
  const [roles, setRoles] = useState([]);
  const [permissions, setPermissions] = useState([]);
  //context
  const { saving, createItem, apiErrors, modalTogle, modal, item, updateItem } =
    useContext(RoleContext);
  //form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };
  useEffect(() => {
    reset({
      name: item?.name,
    });

    if (item?.permissions) {
      setPermissions(item.permissions);

      item?.permissions.forEach((element) => {
        setValue(`permissions.[${element.name}]`, true);
      });
    }
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    setValue("role_id", item?.role_id);
  }, [roles]);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="roleForm">
      <Modal isOpen={modal} toggle={modalTogle} className="rounded-1" size="xl">
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar Rol" : "Agregar Rol"}
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <Form className="form-bookmark">
            <Row>
              <Col md="12">
                <div className="row g-2">
                  <FormGroup className="mb-3 col-md-12">
                    <Label htmlFor="name" className="form-label">
                      Nombre
                    </Label>
                    <input
                      name="name"
                      id="name"
                      className={`form-control ${
                        errors.first_name && "is-invalid"
                      }`}
                      type="text"
                      {...register("name", {
                        required: "El nombre es obligatorio",
                      })}
                      placeholder="Ingresa el nombre del rol"
                      autoComplete="off"
                    />

                    <InputError errors={errors} name="name" />
                  </FormGroup>
                </div>
              </Col>
              <Col md="12">
                <RoleFormPermissions
                  register={register}
                  setValue={setValue}
                ></RoleFormPermissions>
              </Col>
            </Row>
            {/* Botones */}
            <Btn
              attrBtn={{
                color: "secondary",
                className: "ms-1",
                onClick: modalTogle,
              }}
            >
              {Cancel}
            </Btn>
            <Btn
              attrBtn={{
                type: "submit",
                form: "roleForm",

                className: "ms-1",
                color: `${isDirty ? "primary" : "secondary"}`,
                disabled: !isDirty,
              }}
            >
              {Save}
            </Btn>
          </Form>
        </ModalBody>
      </Modal>
    </Form>
  );
}
